import classNames from 'classnames';
import * as PropTypes from 'prop-types';
import React from 'react';
import Icon, { Icons } from '../Icon/Icon';

import './Button.scss';

const Button = ({
	className = null,
	children = null,
	onClick = () => {},
	iconBefore = null,
	iconAfter = null,
	disabled = false,
	loading = false,
	type = 'button',
	iconSize = 24,
	btnSize = 'large',
	styleType = 'primary',
	...props
}) => {
	const getSpinnerColor = styleType => {
		switch (styleType) {
			case 'primary':
				return 'rgb(var(--bg-secondary))';
			case 'secondary':
				return 'rgb(var(--blue-primary))';
			case 'tertiary':
				return 'rgb(var(--blue-primary))';
			case 'green':
				return 'rgb(var(--green))';
			case 'green-dark':
				return 'rgb(var(--green-dark))';
			case 'red':
				return 'rgb(var(red))';
			case 'white':
				return 'rgb(var(--label-primary))';
			default:
				return '#000';
		}
	};

	const isReallyDisabled = disabled && !loading;

	return (
		<button
			className={classNames('Button', className, styleType, btnSize, { loading })}
			onClick={loading || disabled ? undefined : onClick}
			disabled={isReallyDisabled}
			type={type}
			{...props}
		>
			{iconBefore && !loading && <Icon type={Icons[iconBefore]} width={iconSize} height={iconSize} />}
			{loading ? (
				<span className='Button__spinner'>
					<Icon type={Icons.LOADING_SPINNER} width={iconSize} height={iconSize} color={getSpinnerColor(styleType)} />
				</span>
			) : (
				children
			)}
			{iconAfter && !loading && <Icon type={Icons[iconAfter]} width={iconSize} height={iconSize} />}
		</button>
	);
};

Button.propTypes = {
	className: PropTypes.string,
	icon: PropTypes.node,
	disabled: PropTypes.bool,
	children: PropTypes.node,
	onClick: PropTypes.func,
	type: PropTypes.oneOf(['button', 'submit']),
	btnSize: PropTypes.oneOf(['large', 'medium', 'small']),
	styleType: PropTypes.oneOf(['primary', 'secondary', 'tertiary', 'ghost', 'white', 'green', 'green-dark', 'red']),
	iconSize: PropTypes.number,
	loading: PropTypes.bool,
};

export default Button;
